import type { Rarity } from '#src/__generated__/globalTypes.ts';
import type { SupportedCardSet } from '#src/lib/cardSets.ts';
import { getRarityColor, getRaritySecondaryColor } from '#src/lib/colors.ts';
import { unitMapping } from '#src/lib/style.ts';

type Props = {
  rarity: Rarity | 'mix';
  size?: keyof typeof unitMapping;
  className?: string;
  cardSet?: SupportedCardSet;
};
export const ScarcityIcon = ({
  rarity,
  size = 2,
  className,
  cardSet,
}: Props) => {
  const fill =
    rarity === 'mix'
      ? 'rgba(var(--c-rgb-mix), 1)'
      : getRarityColor(rarity, { cardSet });
  const gradient =
    rarity === 'mix'
      ? 'rgba(var(--c-rgb-mix-secondary), 1)'
      : getRaritySecondaryColor(rarity);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 12"
      fill="none"
      style={{ height: unitMapping[size], aspectRatio: 0.67 }}
      className={className}
    >
      <path
        d="M0.25 1.5C0.25 0.671573 0.921573 0 1.75 0H6.25C7.07843 0 7.75 0.671573 7.75 1.5V10.5C7.75 11.3284 7.07843 12 6.25 12H1.75C0.921573 12 0.25 11.3284 0.25 10.5V1.5Z"
        fill={fill}
      />
      <path
        d="M1.75 0.125H6.25C7.00939 0.125 7.625 0.740609 7.625 1.5V10.5C7.625 11.2594 7.00939 11.875 6.25 11.875H1.75C0.990609 11.875 0.375 11.2594 0.375 10.5V1.5C0.375 0.740609 0.990609 0.125 1.75 0.125Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="0.25"
      />
      <path
        d="M0.546875 7.19085V3.28256L4.12184 1.56396L7.57106 3.28256V7.19085L4.12184 8.83406L0.546875 7.19085Z"
        fill="black"
        fillOpacity="0.1"
      />
      <path
        d="M7.57106 6.02639C7.39204 6.02639 7.52039 5.77536 7.3169 5.71179C7.18184 5.6485 6.02256 5.19314 5.4598 4.97337C5.4065 4.94007 5.29712 4.80164 5.20956 4.69082C5.15844 4.62613 5.11475 4.57084 5.09401 4.55138C5.04899 4.50915 5.05649 4.0767 5.06587 3.86575C5.07525 3.73389 5.12215 3.54925 5.12215 3.54925C5.43166 3.4438 5.4598 2.94273 5.4598 2.94273C5.52733 2.68956 5.31911 2.67902 5.2347 2.78446L5.2347 2.4153C5.2347 2.3942 5.19718 2.0373 5.17842 1.86149C5.17842 1.5626 4.81263 1.07033 4.05291 0.991211C3.1525 1.01231 2.88988 1.58018 2.87112 1.86149L2.87112 2.38892L2.89926 2.78446C2.82423 2.63502 2.67416 2.70539 2.67416 2.91632C2.67416 3.38047 2.91802 3.53167 3.03995 3.54925C3.07747 3.64595 3.15813 3.86571 3.18064 3.9712C3.20315 4.07669 3.17126 4.40194 3.1525 4.55138L2.9274 4.94696C2.4303 5.12277 1.35731 5.50077 1.04217 5.60626C0.727024 5.71175 0.621909 6.07293 0.546875 6.22237L0.546875 6.71985L0.546875 6.68719C0.546875 7.0659 0.546878 7.17588 1.00008 7.37291L4.05291 8.84925L7.17533 7.37291C7.58954 7.37291 7.57106 7.0659 7.57106 6.68719L7.57106 6.02639Z"
        fill={`url(#card-gradient-${rarity})`}
      />
      <path
        d="M4.20725 9.19619L0.530273 7.49268C0.530273 7.96303 0.717145 8.07057 0.843559 8.12584L4.20725 9.76906C5.11413 9.32685 7.13894 8.24644 7.32362 8.12584C7.50829 8.00524 7.54346 7.69368 7.55446 7.49268L4.20725 9.19619Z"
        fill="black"
        fillOpacity="0.1"
      />
      <defs>
        <linearGradient
          id={`card-gradient-${rarity}`}
          x1="4.05903"
          y1="0.241211"
          x2="4.05903"
          y2="8.84925"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradient} />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
